module.exports = __webpack_public_path__ + "img/result-detail-invest-icon01.57d1efbe.svg";